import { createContext } from "react";

export type NumberFormatContextType = Intl.NumberFormat;
export const NumberFormatContext = createContext<NumberFormatContextType>(
  undefined as unknown as NumberFormatContextType
);
